<script setup lang="ts">
import { computed } from 'vue';
import { ICON_PATHS } from '@/app/icons';

const props = defineProps<{ name: string; cls?: string }>();
const paths = computed(() => ICON_PATHS[props.name] ?? '');
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -- static, trusted icon paths -->
  <svg :class="['ico', cls]" viewBox="0 0 20 20" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" v-html="paths" />
</template>
